import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { guaranteeItems } from '../data/content';
import { CtaButton } from './CtaButton';
export function Guarantee() {
  return <section className="bg-white px-4 py-14" data-id="element-105" data-mp="223y639n82bl6">
      <div className="mx-auto max-w-2xl text-center" data-id="element-106" data-mp="222n2paxov5ul">
        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-plum" data-id="element-107" data-mp="1x3tpzkq87ivh">
          <ShieldCheckIcon className="h-12 w-12 text-gold" aria-hidden="true" data-id="element-108" data-mp="19e7pmty4axlw" />
        </div>
        <h2 className="mt-5 font-serif text-[28px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-109" data-mp="14g67cb8in2bh">
          7-Day <em className="text-plum" data-id="element-110" data-mp="1j52e84yu69ai">Money-Back</em> Guarantee
        </h2>
        <p className="mt-3 text-[17px] text-muted" data-id="element-111" data-mp="1edu2v3dy4dup">Try The Peaceful Night Method™ completely risk-free. During your first 7 days, you can:</p>
        <ul className="mt-6 grid gap-2 text-left sm:grid-cols-2" data-id="element-112" data-mp="qn7vlebrmxlr">
          {guaranteeItems.map(g => <li key={g} className="flex items-center gap-3 rounded-xl bg-lavender px-4 py-3 text-[15px] font-medium text-ink" data-id="element-113" data-mp="lodceb9vz714">
              <CheckIcon className="h-4 w-4 shrink-0 text-sage-text" aria-hidden="true" data-id="element-114" data-mp="oxfb4c17yttm" /> {g}
            </li>)}
        </ul>
        <p className="mt-6 text-[17px] text-muted" data-id="element-115" data-mp="ypl2pknk798a">
          If you decide the system isn’t right for you, simply request a refund within the guarantee period. <strong className="text-ink" data-id="element-116" data-mp="12q4x4ggqzyqq">No complicated process.</strong>
        </p>
        <CtaButton className="mt-8" label="Try it risk-free for 7 days" data-id="element-117" data-mp="61yx66urtuis" />
      </div>
    </section>;
}